// i18n
import { useTranslation } from 'react-i18next';

// hooks
import { useLearningHub } from '../../../hooks/useLearningHub';

// mui
import { Grid, Link, LinkProps } from '@mui/material';
import { Loading } from '../../ui/Loading/Loading';

export const LinkLearning = ({ ...props }: LinkProps) => {
	// hooks
	const { handleClickLearningHub, statusGetLearningHub } = useLearningHub();
	const { t } = useTranslation();

	return (
		<Link
			color="common.white"
			onClick={handleClickLearningHub}
			sx={{ cursor: 'pointer' }}
			underline="hover"
			{...props}>
			<Grid alignItems="center" container spacing={1}>
				<Grid item>{t('learningHub')}</Grid>
				{statusGetLearningHub === 'LOADING' && (
					<Grid item>
						<Loading CircularProgressProps={{ color: 'inherit' }} size="xs" />
					</Grid>
				)}
			</Grid>
		</Link>
	);
};
